import {FulltextTabView} from "./fulltext-tab";
import {FullTextRevisionsView} from "../partials/full-text-revisions";
import {FullTextRevisionsModel} from "../../models/full-text-revisions";

export class LegislationLatestRevisionView extends FulltextTabView {

    private fullTextRevisionsView: FullTextRevisionsView;

    public onShow() {
        this.setupFullTextRevisionsView();
    }

    public loadDocumentPdf() {
        return null;
    }

    private setupFullTextRevisionsView() {
        try {
            const model = new FullTextRevisionsModel({Id: this.model.Data.Id});
            model.Reference = this.model.Data.get("Citation").Reference;
            this.fullTextRevisionsView = new FullTextRevisionsView({model});
            this.contentRegion.show(this.fullTextRevisionsView);
        } catch (ex) {
            dev.log(ex);
            // Region doesn't exist on open sku. This could be refactored
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/legislation-latest-revision.ts